import fp from 'lodash/fp'
import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'

import * as styles from './styles'

const renderItems = fp.map((item) => (
  <li key={item}>
    <Text size={11}>{item}</Text>
  </li>
))

const StringListCellComponent = ({
  empty,
  value,
  tooltip,
  showMore,
  longerThanExpected,
  onToggleVisibility,
}) =>
  empty ? (
    <Text size={11}>-</Text>
  ) : (
    <ul title={tooltip} css={styles.list}>
      {renderItems(value)}
      {longerThanExpected && (
        <li css={styles.toggle} onClick={onToggleVisibility}>
          <Text size={11}>Show {showMore ? 'Less' : 'More'}</Text>
        </li>
      )}
    </ul>
  )

StringListCellComponent.propTypes = {
  tooltip: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.string),
  longerThanExpected: PropTypes.bool.isRequired,
  empty: PropTypes.bool.isRequired,
  showMore: PropTypes.bool.isRequired,
  onToggleVisibility: PropTypes.func.isRequired,
}

export default StringListCellComponent
